// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/updated.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'collection.updated',
	post: false,
	require: function(config, filter) { return sorted('collection.updated', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('c.collection_date_updated', sortReverse('collection.updated', filter), sortPriority('collection.updated', filter))
	}
}
